import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Space } from "antd";
import {
  HeaderContainer,
  BackButton,
  HeaderContent,
  HeaderTop,
  PageTitle,
  PageSubtitle,
  FiltersContainer,
  FilterLabel,
} from "./styles";
import CustomersDropDown from "../../Loyalty/CustomersDropdown";
import StoresDropDown from "../StoresDropDown";
import { DeliveryCostAnalysisHeaderProps } from "./types";

const DeliveryCostAnalysisHeader: React.FC<DeliveryCostAnalysisHeaderProps> = ({
  merchant,
  storeId,
  user,
  onMerchantChange,
  onStoreChange,
}) => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <BackButton
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        onClick={() => navigate(-1)}
        shape="circle"
        size="large"
        aria-label="Go Back to Analytics Dashboard"
      />
      <HeaderContent>
        <HeaderTop>
          <div>
            <PageTitle level={2}>Delivery Cost Analysis</PageTitle>
            <PageSubtitle>Analyze delivery costs, revenue, and profitability</PageSubtitle>
          </div>
          <FiltersContainer>
            {user.role === "admin" && (
              <Space>
                <FilterLabel>By Merchants</FilterLabel>
                <CustomersDropDown onOptionSelect={onMerchantChange} />
              </Space>
            )}
            <Space>
              <FilterLabel>By Store</FilterLabel>
              <StoresDropDown
                onOptionSelect={onStoreChange}
                merchantId={merchant?.id}
                role={user?.role}
              />
            </Space>
          </FiltersContainer>
        </HeaderTop>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default DeliveryCostAnalysisHeader;
